var _circle, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSplitIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 37,
    height: 36,
    viewBox: "0 0 37 36",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 18.5,
    cy: 18,
    r: 17.5,
    fill: "white",
    stroke: "#DFE2EB"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.0244 24.6667C13.1156 24.6667 13.1872 24.6407 13.2393 24.5886L24.2549 13.573C24.307 13.5209 24.333 13.4493 24.333 13.3582C24.333 13.267 24.307 13.1954 24.2549 13.1433L23.3564 12.2449C23.3044 12.1928 23.2327 12.1667 23.1416 12.1667C23.0505 12.1667 22.9788 12.1928 22.9268 12.2449L11.9111 23.2605C11.859 23.3126 11.833 23.3842 11.833 23.4753C11.833 23.5665 11.859 23.6381 11.9111 23.6902L12.8096 24.5886C12.8617 24.6407 12.9333 24.6667 13.0244 24.6667ZM14.5645 16.3796C14.1632 16.3796 13.816 16.233 13.5228 15.9398C13.2296 15.6466 13.083 15.2994 13.083 14.8982C13.083 14.4969 13.2219 14.142 13.4997 13.8333C13.8083 13.5556 14.1632 13.4167 14.5645 13.4167C14.9657 13.4167 15.3129 13.5633 15.6062 13.8565C15.8994 14.1497 16.046 14.4969 16.046 14.8982C16.046 15.2994 15.8994 15.6466 15.6062 15.9398C15.3129 16.233 14.9657 16.3796 14.5645 16.3796ZM21.0228 23.4398C21.316 23.733 21.6632 23.8796 22.0645 23.8796C22.4657 23.8796 22.8207 23.7407 23.1293 23.463C23.4071 23.1543 23.546 22.7994 23.546 22.3982C23.546 21.9969 23.3994 21.6497 23.1062 21.3565C22.8129 21.0633 22.4657 20.9167 22.0645 20.9167C21.6632 20.9167 21.316 21.0633 21.0228 21.3565C20.7296 21.6497 20.583 21.9969 20.583 22.3982C20.583 22.7994 20.7296 23.1466 21.0228 23.4398Z",
    fill: "#A8B2C8"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSplitIcon);
export default __webpack_public_path__ + "static/media/split-icon.97d7ef4a2bb1f805da667fb868ed37c3.svg";
export { ForwardRef as ReactComponent };